import type { Template } from "@/types";

export const PO_07_H0_V7: Template[] = [
    {
        id: "po-07-h0v7-01",
        name: "PO 01 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 309, width: 190, height: 299, rotation: 0, imageRotation: 0 },
            { id: "2", x: 198, y: 309, width: 190, height: 299, rotation: 0, imageRotation: 0 },
            { id: "3", x: 396, y: 309, width: 190, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 594, y: 309, width: 189, height: 299, rotation: 0, imageRotation: 0 },
            { id: "5", x: 791, y: 309, width: 189, height: 299, rotation: 0, imageRotation: 0 },
            { id: "6", x: 988, y: 309, width: 189, height: 299, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1185, y: 309, width: 189, height: 299, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-02",
        name: "PO 02 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 65, y: 185, width: 181, height: 269, rotation: 0, imageRotation: 0 },
            { id: "2", x: 254, y: 185, width: 180, height: 269, rotation: 0, imageRotation: 0 },
            { id: "3", x: 442, y: 185, width: 180, height: 269, rotation: 0, imageRotation: 0 },
            { id: "4", x: 65, y: 462, width: 181, height: 269, rotation: 0, imageRotation: 0 },
            { id: "5", x: 254, y: 462, width: 180, height: 269, rotation: 0, imageRotation: 0 },
            { id: "6", x: 442, y: 462, width: 180, height: 269, rotation: 0, imageRotation: 0 },
            { id: "7", x: 846, y: 185, width: 369, height: 545, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-03",
        name: "PO 03 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 177, y: 93, width: 163, height: 238, rotation: 0, imageRotation: 0 },
            { id: "2", x: 177, y: 339, width: 163, height: 238, rotation: 0, imageRotation: 0 },
            { id: "3", x: 177, y: 585, width: 163, height: 238, rotation: 0, imageRotation: 0 },
            { id: "4", x: 348, y: 93, width: 163, height: 238, rotation: 0, imageRotation: 0 },
            { id: "5", x: 348, y: 339, width: 163, height: 238, rotation: 0, imageRotation: 0 },
            { id: "6", x: 348, y: 585, width: 163, height: 238, rotation: 0, imageRotation: 0 },
            { id: "7", x: 793, y: 93, width: 475, height: 730, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-04",
        name: "PO 04 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_04.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 35, y: 0, width: 617, height: 916, rotation: 0, imageRotation: 0 },
            { id: "2", x: 731, y: 154, width: 195, height: 300, rotation: 0, imageRotation: 0 },
            { id: "3", x: 934, y: 154, width: 195, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1137, y: 154, width: 194, height: 300, rotation: 0, imageRotation: 0 },
            { id: "5", x: 731, y: 462, width: 195, height: 300, rotation: 0, imageRotation: 0 },
            { id: "6", x: 934, y: 462, width: 195, height: 300, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1137, y: 462, width: 194, height: 300, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-05",
        name: "PO 05 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_05.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 55, y: 243, width: 285, height: 431, rotation: 0, imageRotation: 0 },
            { id: "2", x: 348, y: 243, width: 139, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 463, width: 139, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 495, y: 243, width: 138, height: 212, rotation: 0, imageRotation: 0 },
            { id: "5", x: 495, y: 463, width: 138, height: 211, rotation: 0, imageRotation: 0 },
            { id: "6", x: 741, y: 243, width: 286, height: 431, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1035, y: 243, width: 285, height: 431, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-06",
        name: "PO 06 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 65, y: 174, width: 441, height: 569, rotation: 0, imageRotation: 0 },
            { id: "2", x: 739, y: 174, width: 379, height: 569, rotation: 0, imageRotation: 0 },
            { id: "3", x: 514, y: 174, width: 124, height: 185, rotation: 0, imageRotation: 0 },
            { id: "4", x: 514, y: 367, width: 124, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 514, y: 559, width: 124, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1126, y: 174, width: 186, height: 281, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1126, y: 463, width: 186, height: 280, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-07",
        name: "PO 07 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 68, y: 89, width: 242, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 463, width: 242, height: 365, rotation: 0, imageRotation: 0 },
            { id: "3", x: 318, y: 89, width: 242, height: 366, rotation: 0, imageRotation: 0 },
            { id: "4", x: 318, y: 463, width: 242, height: 365, rotation: 0, imageRotation: 0 },
            { id: "5", x: 568, y: 89, width: 490, height: 739, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1066, y: 89, width: 241, height: 366, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1066, y: 463, width: 241, height: 365, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-08",
        name: "PO 08 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 68, y: 89, width: 242, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 463, width: 242, height: 365, rotation: 0, imageRotation: 0 },
            { id: "3", x: 318, y: 89, width: 242, height: 366, rotation: 0, imageRotation: 0 },
            { id: "4", x: 318, y: 463, width: 242, height: 365, rotation: 0, imageRotation: 0 },
            { id: "5", x: 568, y: 89, width: 241, height: 366, rotation: 0, imageRotation: 0 },
            { id: "6", x: 568, y: 463, width: 241, height: 365, rotation: 0, imageRotation: 0 },
            { id: "7", x: 817, y: 89, width: 490, height: 739, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-09",
        name: "PO 09 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 68, y: 89, width: 242, height: 366, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 463, width: 242, height: 365, rotation: 0, imageRotation: 0 },
            { id: "3", x: 318, y: 89, width: 491, height: 739, rotation: 0, imageRotation: 0 },
            { id: "4", x: 817, y: 89, width: 241, height: 366, rotation: 0, imageRotation: 0 },
            { id: "5", x: 817, y: 463, width: 241, height: 365, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1066, y: 89, width: 241, height: 366, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1066, y: 463, width: 241, height: 365, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-07-h0v7-10",
        name: "PO 10 - H0V7",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-07-h0_v7_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 217, width: 155, height: 237, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 462, width: 155, height: 236, rotation: 0, imageRotation: 0 },
            { id: "3", x: 163, y: 217, width: 155, height: 237, rotation: 0, imageRotation: 0 },
            { id: "4", x: 163, y: 462, width: 155, height: 236, rotation: 0, imageRotation: 0 },
            { id: "5", x: 326, y: 217, width: 345, height: 481, rotation: 0, imageRotation: 0 },
            { id: "6", x: 679, y: 217, width: 345, height: 481, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1032, y: 217, width: 344, height: 481, rotation: 0, imageRotation: 0 }
        ],
    },

];
